import { MaskedPattern } from "imask";

document.querySelectorAll('input[type="tel"').forEach((elem) => {
  IMask(elem, {
    mask: "+{7}(000)000-00-00",
  });
});
